import { render, staticRenderFns } from "./FacilityPage.vue?vue&type=template&id=cbbaa17a&"
import script from "./FacilityPage.vue?vue&type=script&lang=js&"
export * from "./FacilityPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports